/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Status/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Empty from './Empty/index'
import Invalid from './Invalid/index'
import React from 'react'
import Valid from './Valid/index'



/** @type {import('Simple/types.js').View} */
export default function Status({
  children,
  viewPath = "/App/Form/Data/ProvideData/PatientBirthday/Status",
  onSubmit
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Empty'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Invalid'}>
<Invalid
  viewPath={`${viewPath}/Invalid`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Valid'}>
<Valid
  viewPath={`${viewPath}/Valid`}
 onClick={onSubmit}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}